import api from "@core/api/api";

/**
 * Admin Analytics Service
 * Handles all analytics and reporting API calls for admin features
 */

const ANALYTICS_BASE_URL = "/admin/analytics";

export const adminAnalyticsService = {
  /**
   * Get analytics data based on filters
   * @param {Object} params - Query parameters
   * @returns {Promise} Analytics data
   */
  async getAnalytics(params) {
    const response = await api.get(ANALYTICS_BASE_URL, { params });
    return response.data;
  },

  /**
   * Export analytics report
   * @param {Object} params - Export parameters
   * @returns {Promise} Download response
   */
  async exportReport(params) {
    const response = await api.get(`${ANALYTICS_BASE_URL}/export`, {
      params,
      responseType: "blob",
    });

    // Create download link
    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement("a");
    link.href = url;

    const extension = params.format === "excel" ? "xlsx" : params.format;
    link.setAttribute("download", `analytics-report.${extension}`);

    document.body.appendChild(link);
    link.click();
    link.remove();

    return response.data;
  },

  /**
   * Get system statistics
   * @returns {Promise} System stats
   */
  async getSystemStats() {
    const response = await api.get(`${ANALYTICS_BASE_URL}/system-stats`);
    return response.data;
  },

  /**
   * Get performance metrics
   * @param {Object} params - Query parameters
   * @returns {Promise} Performance metrics
   */
  async getPerformanceMetrics(params) {
    const response = await api.get(`${ANALYTICS_BASE_URL}/performance`, {
      params,
    });
    return response.data;
  },

  /**
   * Get revenue analytics
   * @param {Object} params - Query parameters
   * @returns {Promise} Revenue analytics
   */
  async getRevenueAnalytics(params) {
    const response = await api.get(`${ANALYTICS_BASE_URL}/revenue`, { params });
    return response.data;
  },

  /**
   * Get user analytics
   * @param {Object} params - Query parameters
   * @returns {Promise} User analytics
   */
  async getUserAnalytics(params) {
    const response = await api.get(`${ANALYTICS_BASE_URL}/users`, { params });
    return response.data;
  },
};
